module.exports = __webpack_public_path__ + "img/rightArrow.e512b281.gif";